import $ from "jquery";
import axios from "axios";
import Vue from "Vue";
import AppBase from "../AppBase";
import { Calendar } from "../../models";


export default class CalendarApp extends AppBase {
  constructor() {
    super();

    CalendarApp.ROW_MAX = 6;
    this.dataList = [];
    this.vmList = [];
  }

  init() {
    super.init();

    $("body").click((e) => {
      // console.log($(e.target).closest(".detail"));
      if (!$(e.target).hasClass("hasDetail") && $(e.target).closest(".detail").length <= 0) {
        if (this.currentItem) {
          $(`#${this.currentItem.id}`).fadeOut(10);
          this.currentItem = null;
        }
      }
    });

    for (let i = 0; i < CalendarApp.ROW_MAX; i++) {
      this.dataList.push({
        items: []
      });

      const vm = new Vue({
        el: `#js-calenddarRow${i+1}`,
        data: this.dataList[i],
        methods: {
          detailClick: (eventItem) => {
            if (this.currentItem) {
              $(`#${this.currentItem.id}`).fadeOut(10);
            }

            const $el = $(`#${eventItem.id}`);

            if (this.currentItem && this.currentItem.id === eventItem.id) {
              this.currentItem = null;
              return;
            }

            $el.fadeIn(100);
            this.currentItem = eventItem;
          }
        }
      });

      this.vmList.push(vm);
    }

    axios.get("/data/calendar.json")
    .then(
      response => {
        // console.log(response.data);
        this.calender = new Calendar().init(response.data);
        this.onInit();
        this.dispatcher.trigger("init");
      },
      error => {
        console.log(error);
      }
    );
  }

  onInit() {
    this.render();
    this.updateNavigation();

    $("#js-calenddarPrevButton").click(() => {
      this.calender = this.calender.prevMonth();
      this.render();
      this.updateNavigation();
    });

    $("#js-calenddarNextButton").click(() => {
      this.calender = this.calender.nextMonth();
      this.render();
      this.updateNavigation();
    });
  }

  updateNavigation() {
    $("#js-calenddarPrevButton").prop("disabled", !this.calender.hasPrev);
    $("#js-calenddarNextButton").prop("disabled", !this.calender.hasNext);
  }

  render() {
    const date = this.calender.selected;
    // console.log(date.format("MM-DD-YYYY"));
    $("#js-calenddarYear").html(date.format("gggg"));
    $("#js-calenddarMonth").html(date.format("M"));

    let index = 0;

    for (let i = 0; i < CalendarApp.ROW_MAX; i++) {
      const dayElements = this.calender.dayElements.slice(index, index + 7);
      // console.log(dayElements);
      // const vm = this.vmList[i];
      const data = this.dataList[i];
      // data.items = dayElements.toJS();
      Vue.set(data, "items", dayElements.toJS());
      // vm.$forceUpdate();

      index += 7;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/modules/CalendarApp.js